import { render, staticRenderFns } from "./MessageBoxTags.vue?vue&type=template&id=08daaca5&scoped=true"
import script from "./MessageBoxTags.vue?vue&type=script&lang=js"
export * from "./MessageBoxTags.vue?vue&type=script&lang=js"
import style0 from "./MessageBoxTags.vue?vue&type=style&index=0&id=08daaca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08daaca5",
  null
  
)

export default component.exports